/**
 * Additional scriptures used by the training module (priesthood / core).
 * Canonical English text; same ids as scriptures.training.es.ts.
 */
import type { Scripture } from './scriptures';
import { core3PriesthoodScripturesEn } from './scriptures.training.core3.en';
import { deacon1TrainingScripturesEn } from './scriptures.training.deacon1.en';
import { deacon2TrainingScripturesEn } from './scriptures.training.deacon2.en';
import { teacher2TrainingScripturesEn } from './scriptures.training.teacher2.en';
import { priest1TrainingScripturesEn } from './scriptures.training.priest1.en';
import { priest2TrainingScripturesEn } from './scriptures.training.priest2.en';
import { elder1TrainingScripturesEn } from './scriptures.training.elder1.en';
import { elder2TrainingScripturesEn } from './scriptures.training.elder2.en';
import { highPriest1TrainingScripturesEn } from './scriptures.training.highPriest1.en';
import { highPriest2TrainingScripturesEn } from './scriptures.training.highPriest2.en';
import { manualTrainingScripturesEn } from './scriptures.training.manual.en';

export const scripturesTrainingEn: Scripture[] = [
  {
    id: 'mosiah-2-17',
    reference: 'Mosiah 2:17',
    text: 'And behold, I tell you these things that ye may learn wisdom; that ye may learn that when ye are in the service of your fellow beings ye are only in the service of your God.',
    verses: [
      {
        verse: 17,
        text: 'And behold, I tell you these things that ye may learn wisdom; that ye may learn that when ye are in the service of your fellow beings ye are only in the service of your God.',
      },
    ],
    context: 'King Benjamin teaches that serving others is serving God.',
  },
  {
    id: 'dc-1-30',
    reference: 'Doctrine and Covenants 1:30',
    text: 'And also, to those to whom these commandments were given, might have power to lay the foundation of this church, and to bring it forth out of obscurity and out of darkness, the only true and living church upon the face of the whole earth, with which I, the Lord, am well pleased, speaking unto the church collectively and not individually—',
    verses: [
      {
        verse: 30,
        text: 'And also, to those to whom these commandments were given, might have power to lay the foundation of this church, and to bring it forth out of obscurity and out of darkness, the only true and living church upon the face of the whole earth, with which I, the Lord, am well pleased, speaking unto the church collectively and not individually—',
      },
    ],
    context: 'The Lord declares the restoration of His Church in the last days.',
  },
  {
    id: 'dc-76-22',
    reference: 'Doctrine and Covenants 76:22',
    text: 'And now, after the many testimonies which have been given of him, this is the testimony, last of all, which we give of him: That he lives!',
    verses: [
      {
        verse: 22,
        text: 'And now, after the many testimonies which have been given of him, this is the testimony, last of all, which we give of him: That he lives!',
      },
    ],
    context: 'Joseph Smith and Sidney Rigdon’s testimony of Jesus Christ after the vision of the celestial glory.',
  },
  {
    id: 'articles-of-faith-1-6',
    reference: 'Articles of Faith 1:6',
    text: 'We believe in the same organization that existed in the Primitive Church, namely, apostles, prophets, pastors, teachers, evangelists, and so forth.',
    verses: [
      {
        verse: 6,
        text: 'We believe in the same organization that existed in the Primitive Church, namely, apostles, prophets, pastors, teachers, evangelists, and so forth.',
      },
    ],
    context: 'The Church of Jesus Christ of Latter-day Saints is organized according to the order of the gospel.',
  },
  {
    id: 'alma-34-32',
    reference: 'Alma 34:32',
    text: 'For behold, this life is the time for men to prepare to meet God; yea, behold the day of this life is the day for men to perform their labors.',
    verses: [
      {
        verse: 32,
        text: 'For behold, this life is the time for men to prepare to meet God; yea, behold the day of this life is the day for men to perform their labors.',
      },
    ],
    context: 'Amulek teaches that preparation happens in this life.',
  },
  {
    id: 'dc-20-77-79',
    reference: 'Doctrine and Covenants 20:77, 79',
    text: 'O God, the Eternal Father, we ask thee in the name of thy Son, Jesus Christ, to bless and sanctify this bread to the souls of all those who partake of it, that they may eat in remembrance of the body of thy Son, and witness unto thee, O God, the Eternal Father, that they are willing to take upon them the name of thy Son, and always remember him and keep his commandments which he has given them; that they may always have his Spirit to be with them. Amen. O God, the Eternal Father, we ask thee in the name of thy Son, Jesus Christ, to bless and sanctify this wine to the souls of all those who drink of it, that they may do it in remembrance of the blood of thy Son, which was shed for them; that they may witness unto thee, O God, the Eternal Father, that they do always remember him, that they may have his Spirit to be with them. Amen.',
    verses: [
      {
        verse: 77,
        text: 'O God, the Eternal Father, we ask thee in the name of thy Son, Jesus Christ, to bless and sanctify this bread to the souls of all those who partake of it, that they may eat in remembrance of the body of thy Son, and witness unto thee, O God, the Eternal Father, that they are willing to take upon them the name of thy Son, and always remember him and keep his commandments which he has given them; that they may always have his Spirit to be with them. Amen.',
      },
      {
        verse: 79,
        text: 'O God, the Eternal Father, we ask thee in the name of thy Son, Jesus Christ, to bless and sanctify this wine to the souls of all those who drink of it, that they may do it in remembrance of the blood of thy Son, which was shed for them; that they may witness unto thee, O God, the Eternal Father, that they do always remember him, that they may have his Spirit to be with them. Amen.',
      },
    ],
    context: 'Sacrament prayers on the bread and wine (water) from Doctrine and Covenants 20.',
  },
  {
    id: 'moroni-4-5',
    reference: 'Moroni 4–5',
    text: 'The manner of their elders and priests administering the flesh and blood of Christ unto the church; and they administered it according to the commandments of Christ; wherefore, we know the manner to be true; and the elder or priest did administer it. And they did kneel down with the church, and pray to the Father in the name of Christ, saying: O God, the Eternal Father, we ask thee in the name of thy Son, Jesus Christ, to bless and sanctify this bread to the souls of all those who partake of it, that they may eat in remembrance of the body of thy Son, and witness unto thee, O God, the Eternal Father, that they are willing to take upon them the name of thy Son, and always remember him and keep his commandments which he has given them; that they may always have his Spirit to be with them. Amen. The manner of administering the wine—behold, they took the cup, and said: O God, the Eternal Father, we ask thee in the name of thy Son, Jesus Christ, to bless and sanctify this wine to the souls of all those who drink of it, that they may do it in remembrance of the blood of thy Son, which was shed for them; that they may witness unto thee, O God, the Eternal Father, that they do always remember him, that they may have his Spirit to be with them. Amen.',
    verses: [
      {
        verse: 1,
        text: 'O God, the Eternal Father, we ask thee in the name of thy Son, Jesus Christ, to bless and sanctify this bread to the souls of all those who partake of it, that they may eat in remembrance of the body of thy Son, and witness unto thee, O God, the Eternal Father, that they are willing to take upon them the name of thy Son, and always remember him and keep his commandments which he has given them; that they may always have his Spirit to be with them. Amen.',
      },
      {
        verse: 2,
        text: 'O God, the Eternal Father, we ask thee in the name of thy Son, Jesus Christ, to bless and sanctify this wine to the souls of all those who drink of it, that they may do it in remembrance of the blood of thy Son, which was shed for them; that they may witness unto thee, O God, the Eternal Father, that they do always remember him, that they may have his Spirit to be with them. Amen.',
      },
    ],
    context: 'Book of Mormon sacrament prayers on the bread and wine (water).',
  },
  {
    id: 'moroni-6-1-4',
    reference: 'Moroni 6:1–4',
    text: 'And now I speak concerning baptism. Behold, elders, priests, and teachers were baptized; and they were not baptized save they brought forth fruit meet that they were worthy of it. Neither did they receive any unto baptism save they came forth with a broken heart and a contrite spirit, and witnessed unto the church that they truly repented of all their sins. And none were received unto baptism save they took upon them the name of Christ, having a determination to serve him to the end. And after they had been received unto baptism, and were wrought upon and cleansed by the power of the Holy Ghost, they were numbered among the people of the church of Christ; and their names were taken, that they might be remembered and nourished by the good word of God, to keep them in the right way, to keep them continually watchful unto prayer, relying alone upon the merits of Christ, who was the author and the finisher of their faith.',
    verses: [
      {
        verse: 1,
        text: 'And now I speak concerning baptism. Behold, elders, priests, and teachers were baptized; and they were not baptized save they brought forth fruit meet that they were worthy of it.',
      },
      {
        verse: 2,
        text: 'Neither did they receive any unto baptism save they came forth with a broken heart and a contrite spirit, and witnessed unto the church that they truly repented of all their sins.',
      },
      {
        verse: 3,
        text: 'And none were received unto baptism save they took upon them the name of Christ, having a determination to serve him to the end.',
      },
      {
        verse: 4,
        text: 'And after they had been received unto baptism, and were wrought upon and cleansed by the power of the Holy Ghost, they were numbered among the people of the church of Christ; and their names were taken, that they might be remembered and nourished by the good word of God, to keep them in the right way, to keep them continually watchful unto prayer, relying alone upon the merits of Christ, who was the author and the finisher of their faith.',
      },
    ],
    context: 'Moroni describes baptism and care for members in Christ’s church.',
  },
  {
    id: 'moroni-6-5-6',
    reference: 'Moroni 6:5–6',
    text: 'And the church did meet together oft, to fast and to pray, and to speak one with another concerning the welfare of their souls. And they did meet together oft to partake of bread and wine, in remembrance of the Lord Jesus.',
    verses: [
      {
        verse: 5,
        text: 'And the church did meet together oft, to fast and to pray, and to speak one with another concerning the welfare of their souls.',
      },
      {
        verse: 6,
        text: 'And they did meet together oft to partake of bread and wine, in remembrance of the Lord Jesus.',
      },
    ],
    context: 'The Book of Mormon church gathered often for worship and the sacrament.',
  },
  ...core3PriesthoodScripturesEn,
  ...deacon1TrainingScripturesEn,
  ...deacon2TrainingScripturesEn,
  ...teacher2TrainingScripturesEn,
  ...priest1TrainingScripturesEn,
  ...priest2TrainingScripturesEn,
  ...elder1TrainingScripturesEn,
  ...elder2TrainingScripturesEn,
  ...highPriest1TrainingScripturesEn,
  ...highPriest2TrainingScripturesEn,
  ...manualTrainingScripturesEn,
];
